import Vue from 'vue'
import env from '../../../config/prod.env.js'

const state = {
    exceptions: []
}
  
const mutations = {  
    SET_EXCEPTIONS (state, payload) {
        state.exceptions = payload
    },
    ADD_EXCEPTION (state, payload) {
        state.exceptions.push(payload)
    },
    DELETE_EXCEPTION (state, payload) {
        state.exceptions = state.exceptions.filter(element => {
            return element._id.toString() != payload.toString()
        })    
    },
    UPDATE_EXCEPTION (state, payload) {
        for (let index in state.exceptions) {            
            if (state.exceptions[index]._id == payload._id) {              
              state.exceptions[index] = payload
            }
        }
    },
    API_FAILURE (state, payload) {
      throw {error: true, payload: payload.body}
    } 
}
  
const actions = {
    getExceptions: (context) => {
        return Vue.http.get(`${env.API}/api/schedule/all`)    
            .then(response => {        
                console.log(response)
                context.commit('SET_EXCEPTIONS', response.body.schedules)
                return response.body.schedules
            })
            .catch((error) => {
                return context.commit('API_FAILURE', error)
            })
    },
    createException: (context, data) => {
        const { weekNumber, weekDay } = data
        return Vue.http.post(`${env.API}/api/schedule/create`, { weekNumber, weekDay })    
            .then(response => {        
                context.commit('ADD_EXCEPTION', response.body.schedule)
                return response.body.schedule
            })
            .catch((error) => {
                return context.commit('API_FAILURE', error)
            })
    },
    updateException: (context, data) => {
        const { weekNumber, weekDay, _id } = data
        return Vue.http.put(`${env.API}/api/schedule/update`, { _id, weekNumber, weekDay })    
            .then(response => {
                context.commit('UPDATE_EXCEPTION', response.body.schedule)
                return response.body.schedule
            })
            .catch((error) => {
                console.log(error)
                return context.commit('API_FAILURE', error)
            })
    },
    deleteException: (context, id) => {
        return Vue.http.delete(`${env.API}/api/schedule/delete/${id}`)    
        .then(response => {        
            context.commit('DELETE_EXCEPTION', response.body._id)
            return response.body.success
        })
        .catch((error) => {
            return context.commit('API_FAILURE', error)
        }) 
    },
    getExceptionsByYear: (context, year) => {
        return Vue.http.get(`${env.API}/api/schedule/by-year/${year}`)    
            .then(response => {                        
                context.commit('SET_EXCEPTIONS', response.body.message)
                return response.body.message
            })
            .catch((error) => {
                return context.commit('API_FAILURE', error)
            })
    }
}
  
const getters = {
    getExceptions: (state) => state.exceptions
}
  
export const schedule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/schedule.js